// Section code by type: src/scripts/sections/types/<data-section-type>.js, one lazy chunk each.
// A glob rather than a template-literal import(): roots whose type has no script resolve to null
// instead of a rejected import.
const modules = import.meta.glob('../sections/types/*.js');

const importers = Object.fromEntries(
    Object.entries(modules).map(([path, importer]) => [path.split('/').pop().replace(/\.js$/, ''), importer]),
);

function waitForNetwork() {
    return new Promise((resolve) => window.addEventListener('online', resolve, {once: true}));
}

/**
 * @param {string} type
 * @returns {Promise<object|null>} the section definition, or null when the type has no script
 */
export default async function importSection(type) {
    const importer = importers[type];
    if (!importer) {
        return null;
    }

    try {
        return (await importer()).default;
    } catch (error) {
        // A chunk that failed while offline is retried once the connection is back.
        if (navigator.onLine === false) {
            await waitForNetwork();
            return (await importer()).default;
        }
        throw error;
    }
}
